/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetRuntimeMetadataRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {GetRuntimeMetadataResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const getRuntimeMetadata = (request: GetRuntimeMetadataRequest, options?: CashRequestOptions) => post<GetRuntimeMetadataRequest, GetRuntimeMetadataResponse>("/cash-app/goose-cash/v3/get-runtime-metadata", request, {...options, rejectOnError: true })